import _ from 'lodash'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'

import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, TEXT, YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD, CLUSTER, ROLLUP,  } = DataType;

import isGeographicDataType from 'scoreboard/components/is-geographic-data-type'

function isComplete (filter, field) {
	let dataType = field.dataType
	if (isNumericDataType(dataType)) {
		dataType = NUMBER
	} else if (isGeographicDataType(dataType)) {
		dataType = 'geographic'
	}
	return byType[dataType](filter)
}

const byType = {
	[ROLLUP]: rollupIsComplete,
	'geographic': rollupIsComplete,
	[TEXT]: textIsComplete,
	[CLUSTER]: textIsComplete,
	[NUMBER]: numberIsComplete,
	[DATE]: filter => dateTimeIsComplete(DATE, filter),
	[TIME]: filter => dateTimeIsComplete(TIME, filter),
	[DATE_TIME]: filter => dateTimeIsComplete(DATE_TIME, filter),
	[CALENDAR_PERIOD]: filter => dateTimeIsComplete(CALENDAR_PERIOD, filter),
	[YES_NO]: yesNoIsComplete
}

function rollupIsComplete (filter) {
	// IF ANY OF THIS CHANGES, UPDATE RollupDatasetFilterAdapter.kt ACCORDINGLY
	switch (filter.operator) {
		case 'is':
		case 'is-any':
		case 'is-not-any':
			return _.keys(filter.rollupIsAnyFilters).length > 0 || !_.isEmpty(filter.treeIds)
		case 'contains-all':
		case 'contains-any':
		case 'does-not-contain-all':
		case 'does-not-contain-any':
		case 'begins-with':
		case 'ends-with':
		case 'does-not-begin-with':
		case 'does-not-end-with':
			return !_.isEmpty(filter.values) || !_.isEmpty(filter.equations)
		case 'is-blank':
		case 'not-blank':
			return true
		case 'in-another-tree':
		case 'not-in-another-tree':
			return !_.isNil(filter.anotherTreeFieldId)
		default: return false
	}
}

function textIsComplete (filter) {
	// IF ANY OF THIS CHANGES, UPDATE TextDatasetFilterAdapter.kt ACCORDINGLY
	switch (filter.operator) {
		case 'not-in-any-range':
			return true
		case 'in-the-range':
			return !_.isEmpty(filter.rangeIds)
		default:
			return !_.isEmpty(filter.values) || !_.isEmpty(filter.equations)
	}
}

function numberIsComplete (filter) {
	// IF ANY OF THIS CHANGES, UPDATE NumberDatasetFilterAdapter.kt ACCORDINGLY

	let firstValueSpecified =
		(filter.updateType1 === 'manual' && !_.isNil(filter.value1)) ||
		(filter.updateType1 === 'calculated' && !_.isNil(filter.equation1))

	switch (filter.operator) {
		case 'is-any':
		case 'is-not-any':
			return !_.isEmpty(filter.values) || !_.isEmpty(filter.equations)
		case 'not-in-any-range':
			return true
		case 'less-than':
		case 'less-than-or-equals':
		case 'greater-than':
		case 'greater-than-or-equals':
			return firstValueSpecified
		case 'in-the-range':
			return !_.isEmpty(filter.rangeIds)
		case 'between-number':
			let secondValueSpecified =
				(filter.updateType2 === 'manual' && !_.isNil(filter.value2)) ||
				(filter.updateType2 === 'calculated' && !_.isNil(filter.equation2))
			return firstValueSpecified && secondValueSpecified
		default: return false
	}
}

function dateTimeIsComplete (dataType, filter) {
	// IF ANY OF THIS CHANGES, UPDATE DateDatasetFilterAdapter.kt ACCORDINGLY

	const dateTimeOrDatetimeNSpecified = n => {
		if (dataType === DATE) return !_.isNil(filter[`date${n}`])
		else if (dataType === DATE_TIME) return !_.isNil(filter[`dateTime${n}`])
		else if (dataType === TIME) return !_.isNil(filter[`time${n}`])
		else if (dataType === CALENDAR_PERIOD) return false
		else throw 'Invalid data type'
	}

	const operandNSpecified = n =>
		(isManual(filter[`updateType${n}`]) && (
			dateTimeOrDatetimeNSpecified(n) ||
			!_.isNil(filter[`periodId${n}`]) ||
			!_.isNil(filter[`periodDelta${n}`])
		)) || (
			filter[`updateType${n}`] == 'calculated' &&
			!_.isNil(filter[`equation${n}`])
		)

	switch (filter.operator) {
		case 'is-blank':
		case 'not-blank':
			return true
		case 'before':
		case 'after':
			return operandNSpecified(1)
		case 'between-date-time':
			return operandNSpecified(1) && operandNSpecified(2)
		case 'in-any-period':
		case 'is-period':
			return !_.isEmpty(filter.periodIds)
		case 'on-any-date':
			return !_.isEmpty(filter.dates) || !_.isEmpty(filter.equations)
		case 'at-any-time':
			return !_.isEmpty(filter.times)
		case 'on-day-of-the-week':
			return !_.isEmpty(filter.days)
		case 'in-month-of-the-year':
			return !_.isEmpty(filter.months)
		case 'in-period':
			return !_.isNil(filter.periodId1) || !_.isNil(filter.periodDelta1)
		default:
			return false
	}
}

function isManual (updateType) {
	return _.isNil(updateType) || updateType === 'manual'
}

function yesNoIsComplete (filter) {
	// IF ANY OF THIS CHANGES, UPDATE YesNoDatasetFilterAdapter.kt ACCORDINGLY

	switch (filter.operator) {
		case 'is-any':
		case 'is-not-any':
			return !_.isEmpty(filter.values)
		case 'equals-equation':
			return !_.isEmpty(filter.equations)
		default:
			return false
	}
}

export default isComplete

isComplete.__filename__ = 'datasets/filters/is-complete.js'
